export default {
      id: "timeframe-usage",
      viewBox: "0 0 17 18",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#timeframe",
      toString: function () {
        return this.url;
      }
    }